import { render, staticRenderFns } from "./summary_router.vue?vue&type=template&id=c4409236&scoped=true"
import script from "./summary_router.vue?vue&type=script&lang=js"
export * from "./summary_router.vue?vue&type=script&lang=js"
import style0 from "./summary_router.vue?vue&type=style&index=0&id=c4409236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4409236",
  null
  
)

export default component.exports